<!-- superadmin-jobs.component.html -->

<div class="saj">

  <!-- ── Header ──────────────────────────────────── -->
  <div class="saj__header">
    <div>
      <h1 class="saj__title">All Jobs</h1>
      <p class="saj__subtitle">Every job created across all companies on FieldOps.</p>
    </div>
    <div class="saj__header-right">
      <div class="saj__search-wrap">
        <svg class="saj__search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8"/>
          <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <input
          class="saj__search"
          type="text"
          placeholder="Search by title, location or company…"
          [(ngModel)]="searchQuery"
          (input)="applyFilter()"/>
      </div>

      <!-- Company filter -->
      <div class="saj__select-wrap">
        <svg class="saj__select-icon" width="13" height="13" viewBox="0 0 24 24" fill="none">
          <path d="M3 21V7L12 3L21 7V21" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <select class="saj__select"
                [(ngModel)]="selectedCompany"
                (change)="applyFilter()">
          <option value="">All Companies</option>
          <option *ngFor="let c of companyNames" [value]="c">{{ c }}</option>
        </select>
      </div>

      <!-- Status filter -->
      <div class="saj__select-wrap">
        <svg class="saj__select-icon" width="13" height="13" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
          <polyline points="12 6 12 12 16 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <select class="saj__select"
                [(ngModel)]="selectedStatus"
                (change)="applyFilter()">
          <option value="">All Statuses</option>
          <option value="0">Pending</option>
          <option value="1">In Progress</option>
          <option value="2">Completed</option>
          <option value="3">Failed</option>
        </select>
      </div>
    </div>
  </div>

  <!-- ── Summary chips ───────────────────────────── -->
  <div class="saj__chips" *ngIf="!loading">
    <div class="saj__chip">
      <span class="saj__chip-dot saj__chip-dot--all"></span>
      <span class="saj__chip-label">Total</span>
      <span class="saj__chip-val">{{ jobs.length }}</span>
    </div>
    <div class="saj__chip">
      <span class="saj__chip-dot saj__chip-dot--pending"></span>
      <span class="saj__chip-label">Pending</span>
      <span class="saj__chip-val">{{ countByStatus(0) }}</span>
    </div>
    <div class="saj__chip">
      <span class="saj__chip-dot saj__chip-dot--progress"></span>
      <span class="saj__chip-label">In Progress</span>
      <span class="saj__chip-val">{{ countByStatus(1) }}</span>
    </div>
    <div class="saj__chip">
      <span class="saj__chip-dot saj__chip-dot--complete"></span>
      <span class="saj__chip-label">Completed</span>
      <span class="saj__chip-val">{{ countByStatus(2) }}</span>
    </div>
    <div class="saj__chip">
      <span class="saj__chip-dot saj__chip-dot--failed"></span>
      <span class="saj__chip-label">Failed</span>
      <span class="saj__chip-val">{{ countByStatus(3) }}</span>
    </div>
  </div>

  <!-- ── Table Card ──────────────────────────────── -->
  <div class="saj__card">

    <!-- Loading -->
    <div class="saj__loading" *ngIf="loading">
      <div class="saj__spinner"></div>
      <span>Loading jobs…</span>
    </div>

    <!-- Empty -->
    <div class="saj__empty" *ngIf="!loading && filtered.length === 0">
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.4"/>
        <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7"
              stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      </svg>
      <p>{{ searchQuery || selectedCompany || selectedStatus ? 'No jobs match your filters.' : 'No jobs created yet.' }}</p>
    </div>

    <!-- Table -->
    <div class="saj__table-wrap" *ngIf="!loading && filtered.length > 0">
      <table class="saj__table">
        <thead>
          <tr>
            <th class="saj__th">Job</th>
            <th class="saj__th">Company</th>
            <th class="saj__th">Location</th>
            <th class="saj__th saj__th--center">Status</th>
            <th class="saj__th saj__th--center">Logs</th>
            <th class="saj__th">Created</th>
          </tr>
        </thead>
        <tbody>
          <tr class="saj__row" *ngFor="let j of pagedJobs">

            <!-- Job -->
            <td class="saj__td">
              <div class="saj__job-cell">
                <div class="saj__job-icon">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/>
                    <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7"
                          stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                  </svg>
                </div>
                <span class="saj__job-title">{{ j.title }}</span>
              </div>
            </td>

            <!-- Company -->
            <td class="saj__td">
              <div class="saj__company-pill">
                <div class="saj__company-dot">
                  {{ j.companyName?.charAt(0)?.toUpperCase() }}
                </div>
                <span class="saj__company-name">{{ j.companyName }}</span>
              </div>
            </td>

            <!-- Location -->
            <td class="saj__td saj__td--muted">
              <div class="saj__location">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C8.1 2 5 5.1 5 9C5 14.2 12 22 12 22S19 14.2 19 9C19 5.1 15.9 2 12 2Z"
                        stroke="currentColor" stroke-width="1.8"/>
                  <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="1.8"/>
                </svg>
                {{ j.locationName }}
              </div>
            </td>

            <!-- Status -->
            <td class="saj__td saj__td--center">
              <span class="saj__status"
                    [class.saj__status--pending]="j.status === 0"
                    [class.saj__status--progress]="j.status === 1"
                    [class.saj__status--complete]="j.status === 2"
                    [class.saj__status--failed]="j.status === 3">
                <span class="saj__status-dot"></span>
                {{ getStatusLabel(j.status) }}
              </span>
            </td>

            <!-- Logs -->
            <td class="saj__td saj__td--center">
              <span class="saj__log-count"
                    [class.saj__log-count--zero]="j.logCount === 0">
                {{ j.logCount }}
              </span>
            </td>

            <!-- Created -->
            <td class="saj__td saj__td--muted saj__td--nowrap">
              {{ j.createdUtc | date:'MMM d, y' }}
            </td>

          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <div class="saj__pagination" *ngIf="totalPages > 1">
        <span class="saj__pagination-info">
          Showing {{ (currentPage - 1) * pageSize + 1 }}–{{ Math.min(currentPage * pageSize, filtered.length) }}
          of {{ filtered.length }} jobs
        </span>
        <div class="saj__pagination-controls">
          <button class="saj__page-btn"
                  (click)="goToPage(currentPage - 1)"
                  [disabled]="currentPage === 1">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="saj__page-btn saj__page-btn--num"
                  *ngFor="let p of pageNumbers"
                  [class.saj__page-btn--active]="p === currentPage"
                  (click)="goToPage(p)">{{ p }}</button>
          <button class="saj__page-btn"
                  (click)="goToPage(currentPage + 1)"
                  [disabled]="currentPage === totalPages">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

    </div>
  </div>

</div>